<h2 mat-dialog-title translate>Attachments</h2>
<mat-dialog-content>
  <div style="max-height: 450px">
    <mat-table #table [dataSource]="docAttachments" matSort matSortDisableClear id="docAttachmentDataTable" aria-label="Document Attachment Data Table" tabindex="0">
      <ng-container matColumnDef="DocumentDescription">
        <mat-header-cell *matHeaderCellDef style="min-width:200px;"><span translate>Description</span></mat-header-cell>
        <mat-cell *matCellDef="let attachment" style="min-width:200px;">
          <a (click)="viewAttachmentClick(attachment.SpedDocumentId)" style="cursor: pointer;" aria-label="View Document">
            {{attachment.DocumentDescription}}
          </a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="DocumentName">
        <mat-header-cell *matHeaderCellDef style="min-width:250px;"><span translate>File Name</span></mat-header-cell>
        <mat-cell *matCellDef="let attachment" style="min-width:250px;">{{attachment.DocumentName}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="CreatedDate">
        <mat-header-cell *matHeaderCellDef style="max-width:120px;"><span translate>Attached</span></mat-header-cell>
        <mat-cell *matCellDef="let attachment" style="max-width:120px;">{{attachment.CreatedDate| date: 'MM/dd/yy'}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="AttachedBy">
        <mat-header-cell *matHeaderCellDef style="max-width:200px;"><span translate>Attached By</span></mat-header-cell>
        <mat-cell *matCellDef="let attachment" style="max-width:200px;">{{attachment.AttachedBy}}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="attachmentDataRow{{i}}" tabindex="0"
               style="padding:0px;overflow: hidden;" [attr.aria-label]="getAriaRow(row)" matRipple class="element-row">
      </mat-row>
    </mat-table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>
